export const selectMFALoading = (state) => state.mfa.loading;
export const selectMFAError = (state) => state.mfa.error;
export const selectEnrollmentRequired = (state) => state.mfa.enrollmentRequired;
export const selectMFARequired = (state) => state.mfa.mfaRequired;
export const selectEnrollmentToken = (state) => state.mfa.enrollmentToken;
export const selectMFAToken = (state) => state.mfa.mfaToken;
export const selectEnrollment = (state) => state.mfa.enrollment;
export const selectRecoveryCodes = (state) => state.mfa.recoveryCodes;
export const selectRecoveryCodesRemaining = (state) => state.mfa.recoveryCodesRemaining;
